import apisauce from 'apisauce'
import DevConfig from 'Config/DevConfig'

const BASE_URL = DevConfig.__DEV__ && DevConfig.useLocalAPI
  ? 'http://localhost:5000/digi-clearance/us-central1'
  : 'https://us-central1-digi-clearance.cloudfunctions.net'

const create = (baseURL = BASE_URL) => {
  const config = {
    // base URL is read from the "constructor"
    baseURL,
    // here are some default headers
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json'
    },
    // 10 second timeout...
    timeout: 10000
  }

  const api = apisauce.create(config)

  const login = (username, password) => {
    return api.post('login', { username, password })
  }

  return {
    login
  }
}

export default {
  create
}



// WEBPACK FOOTER //
// ./src/Services/Api.js